module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar4-f17f3944.svg";